import { render, staticRenderFns } from "./TablaProductos.vue?vue&type=template&id=6651b7bf&scoped=true&"
import script from "./TablaProductos.vue?vue&type=script&lang=js&"
export * from "./TablaProductos.vue?vue&type=script&lang=js&"
import style0 from "./TablaProductos.vue?vue&type=style&index=0&id=6651b7bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651b7bf",
  null
  
)

export default component.exports